import { render, staticRenderFns } from "./CaseTop.vue?vue&type=template&id=2b34938f&scoped=true"
import script from "./CaseTop.vue?vue&type=script&lang=js"
export * from "./CaseTop.vue?vue&type=script&lang=js"
import style0 from "./CaseTop.vue?vue&type=style&index=0&id=2b34938f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b34938f",
  null
  
)

export default component.exports